const getDisplayValuesForOuType = (ouType) => {
  switch (ouType) {
    case 'PRIMARY':
      return {
        displayOuType: 'de school',
        displayMgmtTeam: 'de directie',
        sortOrder: 1
      }
    case 'SECONDARY':
     return {
      displayOuType: 'de school',
      displayMgmtTeam: 'de directie',
      sortOrder: 2
     }
    case 'CVO':
      return {
        displayOuType: 'het centrum',
        displayMgmtTeam: 'de directie',
        sortOrder: 3
      }
    case 'BOARDING':
      return {
        displayOuType: 'het internaat',
        displayMgmtTeam: 'de directie',
        sortOrder: 4
      }
    case 'LEERSTEUNCENTRUM':
      return {
        displayOuType: 'het leersteuncentrum',
        displayMgmtTeam: 'de directie',
        sortOrder: 5
      }
    case 'GOVERNINGINSTITUTION':
      return {
        displayOuType: 'de koepel',
        displayMgmtTeam: 'de algemeen directeur, de voorzitter en/of de beheerder',
        sortOrder: 6
      }
    default:
      return {
        displayOuType: 'de instelling',
        displayMgmtTeam: 'de directie',
        sortOrder: 7
      }
    }
  };

/* eslint-disable max-len */
module.exports = ['constants', '$oauth', 'sriClient', 'Utils', 'dateUtils',
  function (constants, $oauth, sriClient, Utils, dateUtils) { //eslint-disable-line

  const EDUCATION_LEVEL_MAP = {
    PRIMARY: new Set([
      constants.mainstructures[111],
      constants.mainstructures[121],
      constants.mainstructures[211],
      constants.mainstructures[221],
    ]),
    SECONDARY: new Set([
      constants.mainstructures[311],
      constants.mainstructures[312],
      constants.mainstructures[321],
    ]),
    CVO: new Set([
      constants.mainstructures[317],
      constants.mainstructures[417],
      constants.mainstructures[618],
    ]),
    BOARDING: new Set([
      constants.mainstructures[411],
      constants.mainstructures[511],
    ])
  };

  const service = { data: {} };

  service.getUserKey = async () => {
    if (service.user && service.user.key) {
      return service.user.key;
    }
    const me = await $oauth.getMe();
    service.user = {
      username: me.username,
      key: me.uuid
    };
    return service.user.key;
  }

  service.getAllPreventieAdviseurResponsibilities = async () => {
    if (service.data.responsibilities) {
      return service.data.responsibilities;
    }
    const personKey = await service.getUserKey();
    const responsibilities  = await sriClient.getAll('/responsibilities', {
      persons: `/persons/${personKey}`,
      positions: `${constants.preventieAdviseurPosition.href},${constants.hoofdVanPreventiePosition.href}`,
      date: dateUtils.getNow(),
      limit: 5000
    });

    service.data.responsibilities = responsibilities;
    return responsibilities;
  };

  service.getAllGovernedOuHrefs = async (ouHrefs) => {
    const relations = await sriClient.getAll('/sam/organisationalunits/relations', {
      type: 'GOVERNS',
      'to.type': 'SCHOOL,SCHOOLENTITY,BOARDING,ALGEMEEN_LEERSTEUNCENTRUM,SPECIFIEK_LEERSTEUNCENTRUM',
      from: ouHrefs.join(','),
      status: 'ACTIVE',
      limit: 5000,
    });

    return relations.map(rel => rel.to.href);
  };

  service.getGoverningInstitutions = async (ouHrefs) => {
    const relations = await sriClient.getAll('/sam/organisationalunits/relations', {
      type: 'GOVERNS',
      'from.type': 'GOVERNINGINSTITUTION',
      to: ouHrefs.join(','),
      expand: 'results.from',
      status: 'ACTIVE',
      limit: 5000,
    });

    return relations.map(rel => rel.from.$$expanded);
  };

  service.fetchOuEpdsAndLocationsData = async (ouHrefs) => {
    const ous = await sriClient.getAllHrefs(ouHrefs);

    const schools = ous.filter(ou => ou.type === 'SCHOOLENTITY' || ou.type === 'SCHOOL');
    const epds = schools.length === 0 ? [] : await sriClient.getAllReferencesTo('/sam/educationalprogrammedetails', {
      hasMainstructure: true,
    }, 'organisationalUnit', schools.map(s => s.$$meta.permalink));    

    const schoolEntities = ous.filter(ou => ou.type === 'SCHOOLENTITY');
    const locations = schoolEntities.length === 0 ? [] : await sriClient.getAllReferencesTo('/sam/organisationalunits/locations', {
      status: 'ACTIVE',
      expand: 'results.physicalLocation',
      typeIn: 'CAMPUS'
    }, 'organisationalUnit', schoolEntities.map(s => s.$$meta.permalink)  );

    return { ous, epds, locations };
  }

  service.getAllContactDetails = async (ouHrefs) => {
    const contactDetails = await sriClient.getAllReferencesTo('/sam/organisationalunits/contactdetails', {
      type: 'MAIL'
    }, 'organisationalUnit', ouHrefs);

    return contactDetails
  }

  service.groupEpdsByOu = (epds) => {
    const epdsPerOu = {};
    epds.forEach(epd => {
      if (!epdsPerOu[epd.organisationalUnit.href]) {
        epdsPerOu[epd.organisationalUnit.href] = [];
      }
      epdsPerOu[epd.organisationalUnit.href].push(epd);
    });
    return epdsPerOu;
  }

  service.convertDataToMaps = ({ ous, epdsPerOu, contactDetails, locations }) => {
    return {
      ous: Object.fromEntries(ous.map(ou => [ou.$$meta.permalink, ou])),
      epds: epdsPerOu,
      contactDetails: Object.fromEntries(contactDetails.map(cd => [cd.organisationalUnit.href, cd])),
      locations: Object.fromEntries(locations.map(loc => [loc.$$meta.permalink, loc]))
    }
  };
  service.getEducationLevel = (ou, epds) => {
    if (ou.type !== 'SCHOOL' && ou.type !== 'SCHOOLENTITY') {
      return null;
    }
    const mainstructureHrefs = epds ? epds.map(epd => epd.mainstructure.href) : [];
    return Object.keys(EDUCATION_LEVEL_MAP).find(level => mainstructureHrefs.some(href => EDUCATION_LEVEL_MAP[level].has(href)));
  }
  service.calculateVm = ({ ous, epds, contactDetails, locations }) => {
    const ouVm = {};
    const locationsPerOu = {};
    Object.values(locations).forEach(loc => {
      if (!locationsPerOu[loc.organisationalUnit.href]) {
        locationsPerOu[loc.organisationalUnit.href] = [];
      }
      locationsPerOu[loc.organisationalUnit.href].push(loc);
    });
    Object.values(ous).forEach(ou => {
      const educationLevel = service.getEducationLevel(ou, epds[ou.$$meta.permalink]);
      const type = educationLevel || (ou.type === 'SPECIFIEK_LEERSTEUNCENTRUM' || ou.type === 'ALGEMEEN_LEERSTEUNCENTRUM' ? 'LEERSTEUNCENTRUM' : ou.type);
      ouVm[ou.$$meta.permalink] = {
        href: ou.$$meta.permalink,
        name: ou.$$displayName,
        ouType: ou.type,
        type,
        ...getDisplayValuesForOuType(type),
        educationLevel,
        address: Utils.getOrganisationalUnitAddress(contactDetails[ou.$$meta.permalink]),
        locations: (locationsPerOu[ou.$$meta.permalink] || []).map(loc => ({
          display: Utils.getLocationAddress(loc.physicalLocation.$$expanded),
          href: loc.physicalLocation.href
        }))
      };
    });
    return ouVm;
  }

  service.getRelevantOusForUser = async () => {
    if (service.vm) {
      return service.vm;
    }
    const responsibilities = await service.getAllPreventieAdviseurResponsibilities();
    const headPreventieAdviseurResps = responsibilities.filter(resp => resp.position.href === constants.hoofdVanPreventiePosition.href);

    // if you are hoofd van preventie in a governing institution you can also start WellBe in all OUs that are governed by the governing institution
    const governedOuHrefs = headPreventieAdviseurResps.length === 0 ? [] : await service.getAllGovernedOuHrefs(headPreventieAdviseurResps.map(resp => resp.organisationalUnit.href));
    const allOuHrefs = Array.from(new Set([...responsibilities.map(resp => resp.organisationalUnit.href), ...governedOuHrefs]));
    // 1. fetch ou data for all ous where the user is preventieadviseur/hoofd preventie + governed ous of governing institution where user is hoofd preventie
    // in step 3 governing institutions will be added (governing institutions do not have epds or locations)
    const { ous, epds, locations } = await service.fetchOuEpdsAndLocationsData(allOuHrefs);
    const epdsPerOu = service.groupEpdsByOu(epds);

    // 2. filter ous (at this point because we need to know the education level (info is in epds) of the ou to filter them)
    const ousThatDoWellBe = ous.filter((ou) => {
      if (ou.type !== 'SCHOOL') {
        return true;
      }
      const educationLevel = service.getEducationLevel(ou, epdsPerOu[ou.$$meta.permalink]);
      return educationLevel === 'CVO';
    });
    // 3. Where the user is preventieadviseur in an OU type that does WellBe (for example not in a university), he can also start WellBe for the governing institution of that OU
    const preventieAdviseurInOuThatDoWellBe = responsibilities.filter(resp => resp.position.href === constants.preventieAdviseurPosition.href && ousThatDoWellBe.some(ou => ou.type !== 'GOVERNINGINSTITUTION' && ou.$$meta.permalink === resp.organisationalUnit.href));
    const governingInstitutions = preventieAdviseurInOuThatDoWellBe.length === 0 ? [] : await service.getGoverningInstitutions(preventieAdviseurInOuThatDoWellBe.map(resp => resp.organisationalUnit.href));
    const contactDetails = await service.getAllContactDetails([...allOuHrefs, ...governingInstitutions.map(gi => gi.$$meta.permalink)]);
    const allOusThatDoWellBe = [...ousThatDoWellBe, ...governingInstitutions];

    service.data = { ...service.data, ...service.convertDataToMaps({ous: allOusThatDoWellBe, epdsPerOu, contactDetails, locations}) };
    service.vm = service.calculateVm(service.data);
    return service.vm;
  };

  service.getAllPhysicalLocations = async (plHrefs) => {
    const missingPhsyicalLocationHrefs = plHrefs.filter(plHref => !service.data.locations[plHref]);
    console.log('Missing physical locations to expand in survey list', missingPhsyicalLocationHrefs);
    if (missingPhsyicalLocationHrefs.length === 0) {
      return service.data.locations;
    }
    const missingPhysicalLocations = await sriClient.getAllHrefs(missingPhsyicalLocationHrefs);
    service.data.locations = {
      ...service.data.locations,
      ...Object.fromEntries(missingPhysicalLocations.map(loc => [loc.$$meta.permalink, loc]))
    };
    return service.data.locations;
  };

  service.getPersonsInOuWithPositions = async (ouHref, positions) => {
    const responsibilities = await sriClient.getAll('/responsibilities', {
      organisationalUnit: ouHref,
      positions: positions.join(','),
      date: dateUtils.getNow()
    });
    if (responsibilities.length === 0) {
      return [];
    }

    const persons = await sriClient.getAllHrefs(responsibilities.map(r => r.person.href), {
      omit: 'dateOfBirth,registrationNumber'
    }, { inBatch: '/persons/batch' });

    return persons.map((p) => ({ ...p, positions: responsibilities.filter(r => r.person.href === p.$$meta.permalink).map(r => r.position.$$expanded.name) })).sort((p1, p2) => {
      if (p1.lastName === p2.lastName) {
        return p1.firstName > p2.firstName ? 1 : -1;
      }
      return p1.lastName > p2.lastName ? 1 : -1;
    });
  }

    /**
   * Get all the directors under the governing insitution (official schools)
   * where the given school entity is part
   *
   * @param se: school entity
   */
  service.getManagersOfOu = async (ouHref, ouType) => {
    const managerPositions = ouType === 'GOVERNINGINSTITUTION'
      ?  [
          constants.beheerderPosition.href,
          constants.chairmanPosition.href,
          constants.algemeenDirecteurPosition.href
        ]
      : [constants.directorPosition.href];

    return service.getPersonsInOuWithPositions(ouHref, managerPositions);
  };

  service.getAllPreventieAdvisors = async (ouHref) => {
    return service.getPersonsInOuWithPositions(ouHref, [constants.preventieAdviseurPosition.href]); 
  };

  service.getOuHrefsInSameGoverningInstitution = async (ouHref) => {
    const governsRelations = await sriClient.getAll('/sam/organisationalunits/relations', {
      type: 'GOVERNS',
      status: 'ACTIVE',
      to: ouHref,
    });

    const governedOuHrefs = await sriClient.getAll('/sam/organisationalunits/relations', {
      type: 'GOVERNS',
      status: 'ACTIVE',
      from: governsRelations.map(rel => rel.from.href).join(','),// normally should be only exactly one governing institution
    });

    console.log(`Governing institution relations for ${ouHref}`, governsRelations, `Governed OUs by the same governing institutions:`, governedOuHrefs);

    return governedOuHrefs.map(rel => rel.to.href);
  };

  service.getByHref = async (href) => {
    return sriClient.get(href);
  };

  service.getAddress = async (ou) => {
    const contactdetails = await sriClient.getAll('/sam/organisationalunits/contactdetails', { organisationalUnit: ou.$$meta.permalink, type: 'MAIL' });
    return Utils.getOrganisationalUnitAddress(
      contactdetails.length > 0 ? contactdetails[0] : null
    );
  };

  return service;
}];
